<span class="text">1</span><span class="text">:</span>
<input
  #inputEl
  class="input"
  type="number"
  [valueAsNumber]="value"
  (change)="onInputChange($event)"
/>
